"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_photos__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "5d9c8fbf-24f0-4684-8c5e-d124fa65694c",
    "data-name": "Photos_ic_hi",
    viewBox: "0 0 192 192"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "661487d4-0c3c-41c5-9d2e-ea9ca227d51b",
    "data-name": "Bounding Box",
    points: "0.25 191.75 0.25 0.25 191.75 0.25 191.75 191.75 0.25 191.75",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.41,118.35l12.23-12.23a8,8,0,0,1,11.31,0l35,35V40a16,16,0,0,0-16-16H40A16,16,0,0,0,24,40v89.57l42.21-43a8,8,0,0,1,11.37-.05Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.64,106.13l-12.23,12.23L77.57,86.51a8,8,0,0,0-11.37.05L24,129.57V152a16,16,0,0,0,16,16H152a16,16,0,0,0,16-16V141.18l-35-35A8,8,0,0,0,121.64,106.13Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136,
    cy: 56,
    r: 12.5,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,66.5A12.49,12.49,0,0,1,123.55,55c0,.33-.05.66-.05,1a12.5,12.5,0,0,0,25,0c0-.34,0-.67-.05-1A12.49,12.49,0,0,1,136,66.5Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.9,166.86A16,16,0,0,0,168,152V141.18l-35-35a8,8,0,0,0-11.31,0l-12.23,12.23Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2,86.58l-42.2,43V152a16,16,0,0,0,16,16H152a15.93,15.93,0,0,0,5.9-1.14L77.56,86.52A8,8,0,0,0,66.2,86.58Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,166H40a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16H152a16,16,0,0,0,16-16v-2A16,16,0,0,1,152,166Z",
    opacity: 0.06
  }))), /*#__PURE__*/React.createElement("title", null, "photos-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "e2c7de65-1633-400f-94f0-534a78c44e80",
    "data-name": "Photos_ic"
  }, /*#__PURE__*/React.createElement("use", {
    id: "3826dec2-5734-45b2-b21f-7cb3c83069a7",
    "data-name": "Photos_ic_hi",
    width: 192,
    height: 192,
    transform: "translate(0 0)",
    xlinkHref: "#5d9c8fbf-24f0-4684-8c5e-d124fa65694c"
  })));
}

var _default = ic_photos__dark;
exports.default = _default;